"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestShift = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const query_1 = __importDefault(require("./query"));
const SHIFT_QUERY = (options) => (0, graphql_tag_1.default) `
  query ShiftQuery(
    $shift: ID!
  ) {
    shift(
      id: $shift
      uncommitted: true
    ) {
      ${query_1.default.SHIFT_PARAMS_BASIC}
      ${query_1.default.SHIFT_PARAMS_ATTENDANCE}
      offer ${query_1.default.OFFER}
      transfer {
        ${query_1.default.OFFER_PARAMS_TRANSFER}
      }
      warnings ${query_1.default.EVENT_WARNING}
      ${options?.withCandidates ? query_1.default.SHIFT_PARAMS_CANDIDATES : ''}
      ${options?.withHistory ? query_1.default.SHIFT_PARAMS_HISTORY : ''}
    }
  }
`;
const requestShift = async (variables) => {
    const { withCandidates, withHistory, ...VARIABLES } = variables;
    const { data, errors } = await (0, apollo_1.query)(SHIFT_QUERY({ withCandidates, withHistory }), {
        variables: VARIABLES,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.shift;
};
exports.requestShift = requestShift;
async function requestShiftMap(variables, _, options) {
    return await (0, exports.requestShift)({
        ...variables,
        withCandidates: options?.withCandidates,
        withHistory: options?.withHistory,
    });
}
// async function requestShift (variables, token, options) {
//   const query = `query ShiftQuery (
//     $shift: ID!,
//   ) {
//     shift (
//       id: $shift
//       uncommitted: true
//     ) {
//       ${q.SHIFT_PARAMS_BASIC}
//       ${q.SHIFT_PARAMS_ATTENDANCE}
//       offer ${q.OFFER}
//       transfer {
//         ${q.OFFER_PARAMS_TRANSFER}
//       }
//       warnings ${q.EVENT_WARNING}
//       ${(options?.withCandidates) ? q.SHIFT_PARAMS_CANDIDATES : ''}
//       ${(options?.withHistory) ? q.SHIFT_PARAMS_HISTORY : ''}
//     }
//   }`
//   variables.exchangePeriod = {
//     start: moment().toISOString(),
//     end: moment().add(1, 'months').toISOString()
//   }
//   const response = await fetchRequest({
//     variables,
//     query,
//     token
//   })
//   if (!response) return errUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     // return errUtil.apiError('shift', errors)
//   }
//   return data?.shift
// }
exports.default = requestShiftMap;
